export const SET_EXPENSE_TYPE_ID = 'setExpenseTypeId';
export const SET_EXPENSE_FREQUENCY = 'setExpenseFrequency';
export const SET_EXPENSE_VALUE = 'setExpenseValue';
export const SET_EXPENSE_PERCENTAGE = 'setExpensePercentage';
export const SET_EXPENSE_DESCRIPTION = 'setExpenseDescription';
export const SET_EXPENSE_CLIENT_IDS = 'setExpenseClientIds';
export const SET_EXPENSE_ERROR = 'setExpenseError';
